module.exports = __webpack_public_path__ + "static/pic06-3964ef2fd0de3d00130a9fe74d6f6714.jpg";